<template>
  <v-app-bar
    color="white"
    elevation="1"
    height="64"
    class="px-2"
  >
    <!-- Logo Icon -->
    <template v-slot:prepend>
      <v-btn 
        icon="mdi-calendar-check" 
        color="primary" 
        variant="text" 
        to="/"
        size="large"
      ></v-btn>
    </template>

    <!-- App Title -->
    <v-app-bar-title 
      class="font-weight-bold ml-n1" 
      style="cursor: pointer; user-select: none;" 
      @click="$router.push('/')"
    >
      쉬운캘린더
      <span class="text-body-2 text-medium-emphasis ml-2 d-none d-sm-inline-block">
        대한민국 주요 일정
      </span>
    </v-app-bar-title>

    <v-spacer></v-spacer>

    <!-- Right Side: Today's Date -->
    <div class="d-flex flex-column align-end justify-center mr-2">
      <span class="text-caption text-medium-emphasis font-weight-bold">Today</span>
      <span class="text-body-2 font-weight-bold text-grey-darken-3">
        {{ todayFormatted }}
      </span>
    </div>
  </v-app-bar>

  
</template>

<script>
export default {
  name: 'TheHeader',
  data() {
    return {
      timer: null,
      now: new Date()
    }
  },
  mounted() {
    // 날짜 자동 갱신 (자정 넘길 경우 대비)
    this.timer = setInterval(() => {
      this.now = new Date();
    }, 60000);
  },
  beforeUnmount() {
    if (this.timer) clearInterval(this.timer);
  },
  computed: {
    todayFormatted() {
      const d = this.now;
      const days = ['일', '월', '화', '수', '목', '금', '토'];
      return `${d.getMonth() + 1}월 ${d.getDate()}일 (${days[d.getDay()]})`;
    }
  },
}
</script>